import { inject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { AuthService } from '../../services/authService';
import { PaymentAPI } from '../../services/paymentAPI';
import { UserMessageService } from '../../services/userMessageService';

@inject(Router, AuthService, PaymentAPI, UserMessageService)
export class Purchase {
    constructor(router, authService, api, userMessageService) {
        this.router = router;
        this.authService = authService;
        this.api = api;
        this.userMessageService = userMessageService;
        this.totalCost = 0;
        this.loading = false;
        this.perVideo = false;
        this.quantity = 1;

        this.coupon = null;
        this.couponCode = null;

        this.whitelabel = window.whitelabel || false;
        this.requestCount = this.authService.getAccount().request_count;
    }

    attached() {
      
        this.loading = true;
        this.api.getRequestPackageList(this.authService.getUser().token, this.packageListSuccess.bind(this), this.apiError.bind(this));

    }

    packageListSuccess(list) {
        if(list.length == 1 && list[0].quantity == 1) {
            this.perVideo = true;
        }
        this.requestPackageList = list;
        this.requestPackage = this.requestPackageList[0];
        this.packageChanged();
        this.api.getPublicApiKey(this.authService.getUser().token, this.apiKeySuccess.bind(this), this.apiError.bind(this));
    }

    apiKeySuccess(key) {
        this.renderStripe(key);
        this.api.getPaymentData(this.authService.getUser().token, this.apiPaymentDataSuccess.bind(this), this.apiError.bind(this));
    }

    apiPaymentDataSuccess(last4) {
        this.last4 = last4;
        
        this.loading = false;
    }

    apiError(msg) {
        this.userMessageService.setUserError("user", msg);
        this.loading = false;
    }

    packageChanged() {
        this.subtotal = (this.requestPackage.unit_cost * this.requestPackage.quantity);
        if(this.coupon) {
            switch(this.coupon.type) {
                case "AMOUNT": 
                    this.discount = this.coupon.value;
                    break;
                case "PERCENT":
                    this.discount = this.subtotal * (this.coupon.value / 100);
                    break;
            }
        } else {
            this.discount = 0;
        }
        this.totalCost = this.subtotal - this.discount;
    }

    perVideoChanged() {
        this.subtotal = (this.requestPackage.unit_cost * this.quantity);
        if(this.coupon) {
            switch(this.coupon.type) {
                case "AMOUNT": 
                    this.discount = this.coupon.value;
                    break;
                case "PERCENT":
                    this.discount = this.subtotal * (this.coupon.value / 100);
                    break;
            }
        } else {
            this.discount = 0;
        }
        this.totalCost = this.subtotal - this.discount;
    }

    validateCoupon() {

        this.api.validateCoupon(this.couponCode, 
            this.authService.getUser().token, 
            (coupon) => {
                this.coupon = coupon;
                
                if(this.coupon) {
                    switch(this.coupon.type) {
                        case "AMOUNT": 
                            this.discount = this.coupon.value;
                            break;
                        case "PERCENT":
                            this.discount = Math.floor(this.subtotal * (this.coupon.value / 100));
                            break;
                    }
                } else {
                    this.discount = 0;
                }
                this.totalCost = this.subtotal - this.discount;
                
            }, 
            this.apiError.bind(this));

    }

    submit() {
        if(this.quantity > 0) {
            if(!this.last4) {
                this.stripe.createToken(this.card, {name: this.cardholderName}).then(function (result) {
                    if (result.error) {
                        // Inform the user if there was an error

                        this.displayError.textContent = result.error.message;
                    } else {
                        // Send the token to your server
                        this.processPayment(result.token.id);
                    }
                }.bind(this));
            }
            else {
                this.processPayment(null);
            }
        }
    }



  

    processPayment(token) {
        this.loading = true;
        var data = {
            "account_owner_user_id": this.authService.getAccount().owner_user_id,
            "request_package_id": this.requestPackage.id,
            "quantity": this.perVideo ? this.quantity : null,
            "payment_total": this.totalCost,
            "payment_token": token,
            "coupon_code": this.coupon ? this.coupon.code : null
        };

        this.api.processPackagePurchase(data, this.authService.getUser().token, this.paymentSuccess.bind(this), this.apiError.bind(this));
        
    }

    paymentSuccess(account) {
        
        this.authService.setAccount(account);

        this.userMessageService.setUserMessage("user", "Thank you for your purchase!");

        this.loading = false;
      
        this.router.navigate('home');
    }



    renderStripe(key) {
        // Create a Stripe client
        this.stripe = Stripe(key);

        // Create an instance of Elements
        this.elements = this.stripe.elements();

        // Custom styling can be passed to options when creating an Element.
        // (Note that this demo uses a wider set of styles than the guide below.)
        var style = {
            base: {
                color: '#32325d',
                lineHeight: '24px',
                fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                fontSmoothing: 'antialiased',
                fontSize: '16px',
                '::placeholder': {
                    color: '#aab7c4'
                }
            },
            invalid: {
                color: '#fa755a',
                iconColor: '#fa755a'
            }
        };

        // Create an instance of the card Element
        this.card = this.elements.create('card'/*, { style: style }*/);

        // Add an instance of the card Element into the `card-element` <div>
        this.card.mount('#card-element');

        // Handle real-time validation errors from the card Element.
        this.card.addEventListener('change', function (event) {

            if (event.error) {
                this.displayError.textContent = event.error.message;
            } else {
                this.displayError.textContent = '';
            }
        }.bind(this));
    }
}